import { Address } from '@evermile/customer-tracking/model/address';

export const fixExternalAddress: (externalAddress: Address) => Address = (externalAddress) => {
  let fixedAddressLine1 = externalAddress.addressLine1;
  const lowerCaseAddressLine1 = externalAddress.addressLine1.toLowerCase();

  if (!lowerCaseAddressLine1.includes(externalAddress.city.toLowerCase())) {
    fixedAddressLine1 += ', ' + externalAddress.city;
  }

  if (!lowerCaseAddressLine1.includes(externalAddress.postalCode.toLowerCase())) {
    fixedAddressLine1 += ', ' + externalAddress.postalCode;
  }

  return { ...externalAddress, addressLine1: fixedAddressLine1 };
};
